export default __webpack_public_path__ + "static/media/icon-too-happy-face-empty.93bf6b0d.svg";